import React, { useContext } from 'react'
import styled from 'styled-components'

import { YOLOFlagIcon } from '@Components/Icons'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'
import { UserContext } from '@Globals/User'

const ToCountryWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .countryFlag {
    margin-left: 6px;
  }
`

export const ShippingToCountry = () => {
  const { t } = useTranslation()
  const { store } = useContext(MetadataContext)
  const { userData } = useContext(UserContext)

  const countryCode = userData?.otherCountry?.country || ''
  const countryName = userData?.otherCountry?.countryNameMap?.[parseInt(store?.id, 10) || 0] || ''

  if (!countryCode) {
    return null
  }

  return (
    <ToCountryWrapper>
      <span>
        {t('header:WE_SHIP_TO_X', { arg1: countryName })}
      </span>
      <div className="countryFlag">
        <YOLOFlagIcon country={countryCode} />
      </div>
    </ToCountryWrapper>
  )
}
